import React from "react";

import { Stack, Typography } from "@mui/material";

import ProviderButton from "@app/analytics/components/ProviderButton";
import useConnectCalendar from "@app/analytics/hooks/calendar/useConnectCalendar";
import { CALENDAR_PROVIDERS } from "@app/common/constants/providers";

const CalendarConnectUpsell = () => {
  const { connectCalendar } = useConnectCalendar();

  return (
    <>
      <Typography
        variant="bodyPrimaryReg"
        fontWeight={600}
        color="shades.neutral.800"
      >
        You haven't connected your calendar to Read
      </Typography>
      <Typography
        variant="bodySecondaryReg"
        color="shades.neutral.700"
        lineHeight={1.5}
      >
        Without calendar access, you won't see Upcoming Meetings or Meeting
        Reports associated with calendar events.
      </Typography>
      <Stack
        justifyContent="space-between"
        sx={{ width: "100%" }}
        spacing="6px"
      >
        {CALENDAR_PROVIDERS.map((provider) => (
          <ProviderButton
            key={provider.id}
            icon={
              <img
                src={provider.icon}
                alt={`Connect with ${provider.displayName}`}
              />
            }
            providerId={provider.id}
            onClick={() => connectCalendar(provider.id)}
          >
            Connect with {provider.displayName}
          </ProviderButton>
        ))}
      </Stack>
    </>
  );
};

export default CalendarConnectUpsell;
